// NOTE: the integration doc writes endpoints as bare `/v1/openness-organizations...`,
// but every other endpoint in this app is called as `api/v1/...` through `this.$http`
// (whose baseURL is a bare domain root). Treating the doc's omission as shorthand.
// If every request 404s, this is the first thing to check.
export const API_BASE = "api/v1/openness-organizations";
export const API_BASE_CATEGORIES = "api/v1/openness-organization-categories";

export const STATUS_OPTIONS = [
  {value: "ACTIVE", label: "Faol"},
  {value: "INACTIVE", label: "Faol emas"},
];

export const LANG_TABS = [
  {code: "uz_lat", tabLabel: "UZ"},
  {code: "uz_cyr", tabLabel: "UZ Krill"},
  {code: "ru", tabLabel: "RU"},
  {code: "en", tabLabel: "EN"},
  {code: "kr", tabLabel: "KR"},
];

export const TITLE_LANG_LABELS = {
  uz_lat: "O'zbekcha (lotin)",
  uz_cyr: "Ўзбекча (кирилл)",
  ru: "Русский",
  en: "English",
  kr: "Qoraqalpoqcha",
};

// Backend currently only supports PDF generation for these application_type values.
export const DOWNLOADABLE_APPLICATION_TYPES = [1, 3, 4, 5, 6];

// PLACEHOLDER — replace with the real application_type -> label mapping once provided.
export const APPLICATION_TYPE_LABELS = {
  1: "Turi 1",
  3: "Turi 3",
  4: "Turi 4",
  5: "Turi 5",
  6: "Turi 6",
};
